import React, {useState} from 'react';
import './Invite.css';
import Search from '../../../../../assets/icons/Search.svg';
import RequestedCards from '../RequestedCards/RequestedCards';
import AddIcon from '../../../../../assets/icons/AddIcon.svg';
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {candidateDetailInit, fetchInvitedCandidate} from '../../../../../redux/actions';
import {Col, Pagination, Spin} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import {debounce} from '../../../../../assets/helpers';
import history from '../../../../../routes/history';

function Invite() {
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(24);
	const [query, setQuery] = useState('');
	const [debouncedQuery, setDebouncedQuery] = useState(query);

	const dispatch = useDispatch();
	const invitedCandidates = useSelector(
		(state) => state?.invitedCandidatesReducer?.invitedCandidates,
	);
	const totalInvitedCandidates = useSelector(
		(state) => state?.invitedCandidatesReducer?.totalCounts,
	);
	const loading = useSelector(
		(state) => state?.invitedCandidatesReducer?.loading,
	);
	useEffect(() => {
		dispatch(
			fetchInvitedCandidate({
				query,
				page,
				limit,
			}),
		);
	}, [page, query]);

	const handleSearchChange = (e) => {
		setQuery(e.target.value);
		setPage(1);
	};
  
	const onChangePage = (page) => {
		setPage(page);
	};

	const loadingIcon = <LoadingOutlined style={{fontSize: 24}} spin />;
	return (
		<div className="container">
			<div className="sub-container">
				<div className="buttonandTitle">
					<div className="headingCount">
						Invited Candidates
						<span className="count">
							{totalInvitedCandidates ? totalInvitedCandidates : 0}
						</span>
					</div>
					<button
						className="addCandidateBtn"
            onClick={() => {
              dispatch(candidateDetailInit());
              // history.push("/addCandidateEmail");
              history.push({
                pathname: "/add-candidate",})
                localStorage.removeItem("persist:root");
            }}
					>
						<img src={AddIcon} alt="Add Icon" /> Add Candidate
					</button>
				</div>
				<div className="inputAndButton">
					<div className="inputSearch">
						<img src={Search} className="searchIcon" />
						<input
							onChange={debounce((val) => handleSearchChange(val), 1000)}
							type="text"
							className="search-box"
							placeholder="Search by candidate's email id, name & mobile number"
						/>
					</div>
				</div>
			</div>
			<div className="boxContainer">
				{loading ? (
					<div className="loaderContainer">
						<Spin size="large" indicator={loadingIcon} />
					</div>
				) : (
					<div className="boxes">
						{invitedCandidates?.length > 0 ? (
							invitedCandidates.map((item, index) => {
								return (
									<RequestedCards
										key={index}
										{...item}
										isInvitation={true}
										items={item}
										pictureUrl={item?.users?.Profiles?.PictureUrl}
										Rating={item?.users?.Profiles?.Rating}
										Title={item?.Title}
										ClientRate={item?.ClientRate}
										Minimumbid={item?.MinimumBid}
										BudgetName={item?.BudgetTypes?.BudgetTypeName}
										isInvitedTalent={true}
										EmployerEmail={item?.InvitedBy[0]?.EmployerEmail}
										EmployerName={item?.InvitedBy[0]?.EmployerName}
										InvitedDate={item?.InvitedBy[0]?.InviteDate}
									/>
								);
							})
						) : (
							<Col
								xs={24}
								style={{
									padding: '10px',
									textAlign: 'left',
									color: '#7E7E7E',
									paddingLeft: '23px',
									fontSize: '16px',
								}}
							>
								<div>No candidates found</div>
							</Col>
						)}
					</div>
				)}
			</div>

			{totalInvitedCandidates > 24 ? (
				<Pagination
					total={totalInvitedCandidates}
					current={page}
					pageSize={limit}
					onChange={(page, limit) => onChangePage(page, limit)}
					style={{
						textAlign: 'center',
						marginTop: '20px',
						marginBottom: '15px',
					}}
				/>
			) : (
				''
			)}
		</div>
	);
}

export default Invite;
